import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PasswordNotification from "../../components/Profile/PasswordNotif";

function PasswordNotif() {
  const history = useHistory();
  const [timeLeft, setTimeLeft] = useState(5);
  useEffect(() => {
    // exit early when we reach 0
    if (!timeLeft) return;

    // save intervalId to clear the interval when the
    // component re-renders
    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    // clear interval on re-render to avoid memory leaks
    return () => clearInterval(intervalId);
    // add timeLeft as a dependency to re-rerun the effect
    // when we update it
  }, [timeLeft]);

  if (timeLeft === 0) {
    history.push("/");
    // setTimeLeft(null);
  }
  return <PasswordNotification props={{ timeLeft }} />;
}

export default PasswordNotif;
